import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../libraries';

@BindAll()
export class YxtController {
  /** 获取云学堂权限 */
  async getYxtPermission() {
    return await AjaxBasics.request(EnumAPI.orgidass_get_yxt_permission);
  }

  /** 获取云学堂重定向地址（免密登录） */
  async getYxtUrlV2(body) {
    return await AjaxBasics.request({
      ...EnumAPI.cultivate_get_yxt_url,
      body,
    });
  }
}
